import {
  BoughtProductsDto,
  CustomerCredentials,
  QuoteApiResponse,
  QuoteRequest,
  QuotesData
} from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

/**
 * Client-side API wrapper for quote retrieval and persistence endpoints.
 */
export class QuotesApi {
  /**
   * Retrieves quotes data from a VRN.
   */
  getQuotesDatafromVrn(
    vrn: string,
    isNewSearch: boolean,
    dealerNumber: string,
    countryCode: string,
    token: string,
    successCallback: (data: QuotesData) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = `/api/quotes/getbyvrn?vrn=${vrn}&isNewSearch=${isNewSearch}&dealerNumber=${dealerNumber}&countryCode=${countryCode}`;

    new ApiHelper().getDataSecureAsync(
      url,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  /**
   * Retrieves quotes data from a VIN.
   */
  getQuotesDatafromVin(
    vin: string,
    isNewSearch: boolean,
    dealerNumber: string,
    countryCode: string,
    token: string,
    successCallback: (data: QuotesData) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = `/api/quotes/getbyvin?vin=${vin}&isNewSearch=${isNewSearch}&dealerNumber=${dealerNumber}&countryCode=${countryCode}`;

    new ApiHelper().getDataSecureAsync(
      url,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  /**
   * Retrieves quotes data from an email address.
   */
  getQuotesDatafromEmail(
    email: string,
    dealerNumber: string,
    countryCode: string,
    token: string,
    successCallback: (data: QuotesData) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = `/api/quotes/getbyemail?email=${email}&dealerNumber=${dealerNumber}&countryCode=${countryCode}`;

    new ApiHelper().getDataSecureAsync(
      url,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  /**
   * Logs in and retrieves quotes data using credentials.
   */
  getQuotesByCredentials(
    username: string,
    password: string,
    countryCode: string,
    successCallback: (data: QuotesData) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = '/api/quotes/login';

    const credentials: CustomerCredentials = {
      email: username,
      password: password,
      countryCode: countryCode
    };

    new ApiHelper().postDataAsync(
      url,
      credentials,
      successCallback,
      failureCallback,
      signal
    );
  }

  /**
   * Retrieves quotes data for a persisted quote id.
   */
  getQuotesDataFromId(
    id: string,
    dealerNumber: string,
    countryCode: string,
    token: string,
    successCallback: (data: QuotesData) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = `/api/quotes/${id}?dealernumber=${dealerNumber}&countryCode=${countryCode}`;

    new ApiHelper().getDataSecureAsync(
      url,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  /**
   * Saves a quote.
   */
  saveQuote(
    quoteRequest: QuoteRequest,
    token: string,
    successCallback: (data: QuoteApiResponse) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = 'api/quotes/save';

    new ApiHelper().postDataSecureAsync(
      url,
      quoteRequest,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  /**
   * Marks a quote as bought/saves purchased products.
   */
  saveQuoteBought(
    boughtProductsDto: BoughtProductsDto,
    token: string,
    successCallback: (data: QuoteApiResponse) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `api/quotes/bought`;

    new ApiHelper().postDataSecureAsync(
      dataUrl,
      boughtProductsDto,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
